'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.controller:ClientServiceCtrl
 * @description
 * # BaseService
 * Controller of the thothAppApp
 */
angular.module('thothApp.services', [])
  .factory('BaseService', [
    '$http', '$state', '$rootScope', 'toaster', function($http, $state, $rootScope, toaster) {

      return function() {
        var baseUrl = '';
        var baseModelName = '';

        function createOrSave(params) {
          if('id' in params[baseModelName] && params[baseModelName].id > 0) {
            return $http.put(baseUrl + params[baseModelName].id, params);
          } else {
            return $http.post(baseUrl, params);
          }
        }

        return {
          initialize: function(params) {
            baseUrl = params.baseUrl;
            baseModelName = params.baseModelName;
          },
          index: function(params) {
            return $http.get(baseUrl, params);
          },
          find: function(id, params) {
            return $http.get(baseUrl + id, params);
          },
          save: function(params) {
            return createOrSave(params);
          },
          delete: function(id) {
            return $http.delete(baseUrl + id);
          },
          baseError: function(error) {
            if(error.status === -1) {
              toaster.pop('error', 'Error', 'Hubo un error inesperado. Favor de contactar al administrador del sistema');
            }
            if(error.status === 401) {
              toaster.pop('error', 'Sin Autenticación', error.data.errors);
              $rootScope.isAuthenticated = false;
              $state.go('sign_in');
            }
            if(error.status === 403) {
              toaster.pop('error', 'Error de Permisos', error.data.errors);
            }
            if(error.status === 404) {
              $state.go('error404');
            }
            if(error.status === 422) {
              Object.keys(error.data.errors).forEach((objectKey) => {
                toaster.pop('error', `Error en los parametros ${objectKey}`, error.data.errors[objectKey][0]);
              });
            }
          }
        };
      };
    }
  ]
);
